import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";

export const growthbook = new GrowthBook({
  apiHost: "https://ab-api.aftershoot.co",
  clientKey: "sdk-jsAIhRJWGItljdNE",
  enableDevMode: true,
  trackingCallback: (experiment, result) => {
    console.log("Viewed Experiment", {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
});

export async function initGrowthbook() {
  await growthbook.loadFeatures();
}

export { GrowthBookProvider };
